import React from "react";
import PropTypes from 'prop-types';
import { TextField } from "@material-ui/core";

import "../styles.css"

const status = [
    { value: 'local', label: 'Solicitação para Equipe Local' },
    { value: 'executivo', label: 'Solicitação para Coordenador Executivo' },
    { value: 'civil', label: 'Solicitação para Coordenador Civil' },
];

export default function BasicInfo(props) {
    const handleChange = (event) => {
        props.setValues({
            ...props.values,
            [event.target.id]: event.target.value,
        });
        console.log(event.target.id)
    };

    return (
        <>
            <div className="fundo">
                <div className="autoPAE">
                    <TextField
                        margin="dense"
                        id="termos"
                        label="Termos"
                        placeholder="(&apos;&apos;surgência&apos;&apos; or &apos;&apos;trinca&apos;&apos;)"
                        value={props.values.termos}
                        onChange={handleChange}
                    />
                </div>

                <div className="autoPAE">
                    <TextField
                        margin="dense"
                        id="acao"
                        label="Ação"
                        placeholder="Por favor, entre em contato com o responsável"
                        value={props.values.acao}
                        onChange={handleChange}
                    />
                </div>


                <div className="rowForm">
                    <div className="autoPAE">
                        <TextField
                            select
                            id="status"
                            size="small"
                            label="Tipo"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.status}
                            SelectProps={{ native: true }}
                        >
                            {status.map((option) => (
                                <option key={option.value} value={props.values.status.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>
                </div>
            </div>
        </>
    )
}

BasicInfo.propTypes = {
    update: PropTypes.bool,
    values: PropTypes.object,
    setValues: PropTypes.func
};
